/**
 * @file Filter passed groups
 */

import { UserGroup } from '../../generated/graphql';

import filter, { Options } from '../filter';

type Data = Pick<UserGroup, 'id' | 'title'>;

const options: Options<Data> = {
  keys: ['title'],
};

/**
 * Filter passed groups
 *
 * First return all selected ones
 * (these are visible no matter the search)
 *
 * And then return the rest, filtered by what's typed into search
 *
 * @param search    What the user typed in search box
 * @param groupsAll All the groups available
 * @returns         Filtered array of groups
 */
const getVisibleGroups = (search: string, groupsAll: Data[]): Data[] => {
  // If nothing is searched, then just return everything
  if (search.trim().length === 0) {
    return groupsAll;
  }
  const groupsSearched = filter(groupsAll, search, options);

  return groupsSearched;
};

export default getVisibleGroups;
